// src/DashboardSuperAdmin.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import SuperHome from './SuperHome';
import SuperOrganizations from './SuperOrganizations';
import SuperSettings from './SuperSettings';
import Messages from './Messages';
import SuperBilling from './SuperBilling';
import SuperAuditLog from './SuperAuditLog';
import SuperDisciplines from './SuperDisciplines';
import SuperTaxonomy from './SuperTaxonomy';
import SuperSessions from './SuperSessions';
import SuperKpis from './SuperKpis';
import SuperAdminAiCache from './SuperAdminAiCache';
import SuperAdminAiEntitlements from './SuperAdminAiEntitlements';

// ✅ NOVO:
//import SuperInstruments from './SuperInstruments';
//import SuperLicenses from './SuperLicenses';

import SuperInstrumentsCatalog from './SuperInstrumentsCatalog';
import SuperLicenses from './SuperLicenses';

import SuperSecurityAudit from './SuperSecurityAudit';

const SuperFeatures = () => (
  <div className="bg-white rounded-xl shadow-sm p-3 text-sm text-gray-700">
    <h2 className="text-base font-semibold mb-2">Org Features</h2>
    <p className="text-xs text-gray-500">
      This section will allow toggling features (modules) per organization based
      on their plan (EI only, PI, SmartScheduler, Parent portal, etc.).
    </p>
  </div>
);

const DashboardSuperAdmin = () => {
  const location = useLocation();
  return (
    <BaseLayout role="super_admin">
      <Routes location={location}>
        <Route path="/" element={<SuperHome />} />
        <Route path="organizations" element={<SuperOrganizations />} />
        <Route path="billing" element={<SuperBilling />} />
        <Route path="disciplines" element={<SuperDisciplines />} />
        <Route path="settings" element={<SuperSettings />} />
        <Route path="messages" element={<Messages />} />
        <Route path="audit-log" element={<SuperAuditLog />} />
        <Route path="taxonomy" element={<SuperTaxonomy />} />
        <Route path="sessions" element={<SuperSessions />} />
        <Route path="kpis" element={<SuperKpis />} />
	    <Route path="aicache" element={<SuperAdminAiCache />} />
	    <Route path="entitlements" element={<SuperAdminAiEntitlements />} />

        {/* ✅ NOVO: Instruments & Licenses */}
        <Route path="instruments/*" element={<SuperInstrumentsCatalog />} />
        <Route path="licenses" element={<SuperLicenses />} />
		
		<Route path="security-log" element={<SuperSecurityAudit />} />

        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </BaseLayout>
  );
};

export default DashboardSuperAdmin;


